import feedBack from '../modules/feedBack.js'
export default [
	{path: '/feedBack/index.xhtml',name:'index', component:feedBack.index},
	{path: '/feedBack/feedback.xhtml',name:'feedback', component:feedBack.feedback},
	{path: '/feedBack/success.xhtml',name:'success', component:feedBack.success}
] 